import React from 'react';
import './OpeningHours.css';

const hours = [
  { day: 'Monday', time: '8:00 AM - 6:00 PM', isToday: false },
  { day: 'Tuesday', time: '8:00 AM - 6:00 PM', isToday: false },
  { day: 'Wednesday', time: '8:00 AM - 6:00 PM', isToday: false },
  { day: 'Thursday', time: '8:00 AM - 6:00 PM', isToday: false },
  { day: 'Friday', time: '8:00 AM - 6:00 PM', isToday: false },
  { day: 'Saturday', time: '9:00 AM - 5:00 PM', isToday: true },
  { day: 'Sunday', time: '9:00 AM - 5:00 PM', isToday: false },
];

const OpeningHours = () => (
  <div className="opening-hours">
    <h4 className="opening-hours__title">
      <span className="opening-hours__icon">🕐</span>
      Opening Hours
    </h4>
    <div className="opening-hours__status">
      <span className="status-dot status-dot--open"></span>
      <span className="status-text">Open now</span>
      <span className="status-until">· Closes 5:00 PM</span>
    </div>
    <ul className="opening-hours__list">
      {hours.map((h, idx) => (
        <li key={idx} className={`hours-row ${h.isToday ? 'hours-row--today' : ''}`}>
          <span className="hours-day">{h.day}</span>
          <span className="hours-time">{h.time}</span>
        </li>
      ))}
    </ul>
  </div>
);

export default OpeningHours;
